module.exports = __webpack_public_path__ + "static/media/06.883521f9.jpg";